module.exports = __webpack_public_path__ + "static/img/图层42.a880984.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层42.png
// module id = UEkl
// module chunks = 0